import React from "react"

import PropTypes from "prop-types"

import ButtonTertiary from "../ButtonTertiary/buttonTertiary"

import "./alertButton.scss"

const AlertButton = ({label, onClick = null}) => (
    <ButtonTertiary
        actionType="button"
        className="alert-button"
        icon="fa-regular fa-angle-right"
        iconPosition="right"
        onClick={onClick}
        size="small"
        withoutPadding
    >
        {label}
    </ButtonTertiary>
)

AlertButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
}

export default AlertButton
